var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8861 24.9915C14.7965 24.9912 14.7088 24.9653 14.6335 24.9167C14.5582 24.8682 14.4986 24.7991 14.4614 24.7177C14.4242 24.6362 14.4112 24.5457 14.4239 24.457C14.4366 24.3684 14.4745 24.2852 14.5331 24.2174L19.2241 18.8254C19.2358 18.8109 19.2488 18.7974 19.263 18.7854C19.5319 18.4544 19.668 18.0353 19.645 17.6094C19.6699 17.1413 19.5255 16.6798 19.238 16.3094L19.2201 16.2894L14.529 10.7634C14.4552 10.6682 14.421 10.5481 14.4334 10.4282C14.4459 10.3083 14.5041 10.1978 14.596 10.1198C14.688 10.0418 14.8065 10.0023 14.9269 10.0095C15.0472 10.0167 15.1601 10.0701 15.242 10.1584L19.926 15.6754C20.0642 15.8335 20.1799 16.0098 20.27 16.1994C20.4845 16.6439 20.5905 17.133 20.5791 17.6264C20.6034 18.2996 20.3649 18.9559 19.914 19.4564L15.2361 24.8344C15.1922 24.8839 15.1382 24.9234 15.0779 24.9505C15.0175 24.9776 14.9522 24.9916 14.8861 24.9915Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.4329166684f66b7e18e1aeabe99f3ee7.svg";
export { ForwardRef as ReactComponent };